module.exports = __webpack_public_path__ + "static/aws-a6c1d39637949a370f8e93aab60a741f.png";